export default theme => ({
    root: {
        flexDirection: 'column',
        position: 'fixed',
        right: `calc(${theme.spacing(3)} + 10px)`,
        top: `calc(${theme.spacing(6)} + 10px)`
    },
    spacer: {
        height: theme.spacing(1)
    }
})